<template>
  <form @submit.prevent="submit" class="form-wrapper with-loading" v-form:form novalidate>
    <div class="loading" v-if="isLoading">
      <Loader />
    </div>
    <div class="form-view" v-if="canShowChangePasswordForm">
      <h2 class="title" v-html="title"></h2>
      <div class="form-row" v-if="isUserLogged">
        <div class="input-wrapper">
          <input type="password"
                 v-model="formData.oldPassword"
                 required
                 autocorrect="off"
                 autocomplete="off"
                 spellcheck="false"
                 id="passwordOld"
                 name="passwordOld" />
          <label for="passwordOld">{{ $t('view.component.user.changePassword.labelPasswordOld') }}</label>
        </div>
        <p class="error-field"
           v-if="isErrorForField('passwordOld')"
           v-html="getFieldErrorText('passwordOld')">
        </p>
      </div>
      <div class="form-row">
        <div class="input-wrapper">
          <input type="password"
                 v-model="formData.password"
                 required
                 password
                 autocorrect="off"
                 autocomplete="off"
                 spellcheck="false"
                 id="password"
                 name="password" />
          <label for="password">{{ $t('view.component.user.changePassword.labelPassword') }}</label>
        </div>
        <p class="error-field"
           v-if="isErrorForField('password')"
           v-html="getFieldErrorText('password')">
        </p>
      </div>
      <div class="form-row">
        <div class="input-wrapper">
          <input type="password"
                 v-model="formData.passwordConfirm"
                 required
                 passwordConfirm
                 password-match="password"
                 autocorrect="off"
                 autocomplete="off"
                 spellcheck="false"
                 id="password-confirm"
                 name="password-confirm" />
          <label for="password-confirm">{{ $t('view.component.user.changePassword.labelPasswordConfirm') }}</label>
        </div>
        <p class="error-field"
           v-if="isErrorForField('password-confirm')"
           v-html="getFieldErrorText('password-confirm')">
        </p>
      </div>
      <div class="form-row submit-button-wrapper">
        <button type="submit" class="primary" :class="{disabled: !isFormValid()}">{{ $t('view.component.user.changePassword.buttonSubmit') }}</button>
        <p class="login" v-if="!isUserLogged">
          {{ $t('view.component.user.changePassword.loginText') }}<br>
          <a class="form-link" @click="goToLogin">{{ $t('view.component.user.changePassword.loginLink') }}</a>
        </p>
      </div>
    </div>

    <div class="status-view email-sent" v-if="showConfirmation">
      <div class="img-wrapper">
        <div class="img">
          <img alt="" src="../../assets/images/sent.svg" />
        </div>
        <div>
          <h2>{{ $t('view.component.user.changePassword.confirmationHeader') }}</h2>
          <p>{{ $t('view.component.user.changePassword.confirmationInfo') }}</p>
        </div>
      </div>
      <div class="action-wrapper">
        <button type="button" class="primary" @click="goToLogin">
          {{ $t('view.component.user.changePassword.loginLink') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Loader from '@/orange/components/Loader'
import FormMixin from '@/orange/mixins/form.mixin'
import { mapActions, mapGetters } from 'vuex'
import { ROUTING } from '@/orange/const/routing.const'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'

export default {
  name: 'UserFormChangePassword',
  components: { Loader },
  mixins: [FormMixin],
  props: {
    title: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      showConfirmation: false,
      formData: {
        oldPassword: null,
        password: null,
        passwordConfirm: null
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isUserProcessing',
      isUserLogged: 'isUserLogged'
    }),
    canShowChangePasswordForm: function () {
      return !this.showConfirmation
    }
  },
  methods: {
    ...mapActions([
      'doUserAccountRecoverySetPassword',
      'doUserPasswordChange'
    ]),
    goToHomePage () {
      this.$router.push(ROUTING.main)
    },
    goToLogin () {
      this.$router.push(ROUTING.user.login)
    },
    goToUserData () {
      this.$router.push(ROUTING.user.data)
    },
    setNewPasswordForLoggedUser () {
      const data = {
        oldPassword: this.formData.oldPassword,
        newPassword: this.formData.password
      }
      this.doUserPasswordChange(data)
        .then(() => {
          Notifier.show({
            text: this.$t('view.component.user.changePassword.changePasswordProcessSuccess'),
            type: NOTIFY_TYPE.success
          })
          this.goToUserData()
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.user.changePassword.changePasswordProcessError'),
            type: NOTIFY_TYPE.error
          })
        })
    },
    setNewPasswordForNotLoggedUser () {
      const data = {
        token: this.token,
        password: this.formData.password
      }
      this.doUserAccountRecoverySetPassword(data)
        .then(() => {
          this.showConfirmation = true
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.user.changePassword.changePasswordProcessError'),
            type: NOTIFY_TYPE.error
          })
        })
    },
    submit () {
      this.showConfirmation = false

      if (this.form.invalid) {
        return
      }

      if (this.isUserLogged) {
        this.setNewPasswordForLoggedUser()
      } else {
        this.setNewPasswordForNotLoggedUser()
      }
    }
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
